import { MESSENGER_API_ENDPOINT } from '~config/publicEnv';

import { MrtAxiosException } from '../mrt-error';

export async function messengerRequest<T>(path: string, init: RequestInit = {}) {
  const response = await fetch(`${MESSENGER_API_ENDPOINT}${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      Accept: 'application/json',
      ...(init.body instanceof FormData ? {} : { 'Content-Type': 'application/json' }),
      ...(init.headers || {}),
    },
  });

  const payload = await response
    .json()
    .catch(() => ({ message: response.statusText, code: String(response.status), data: null }));

  if (!response.ok) {
    throw new MrtAxiosException<T>({
      code: payload?.code,
      message: payload?.message || response.statusText,
      data: payload?.data,
      isMrtError: true,
    });
  }

  return { data: payload } as { data: T };
}
